import { data } from 'services';
import { getAmount } from 'libs/common';
import { getDateTime } from 'services/types';

/**
 * get app number
 * @returns
 */
const getAppNumber = (val) => {
  const racksMap = data.getRacksMap();
  return (racksMap && racksMap[val]) || val;
};

export const getTableParams = (t) => {
  const getFields = () => {
    const fields = [
      { name: 'timestamp', sortField: 'timestamp', title: t('grid.Дата и время'), width: 200, render: (val) => getDateTime(val) },
      {
        name: 'payment_type',
        title: t('dict_filter.Способ оплаты'),
        width: 115,
        render: (val) => data.getDictValue('payment.payment_type', val),
      },
      {
        name: 'success',
        title: t('dict_filter.Результат'),
        width: 80,
        render: (val) => data.getDictValue('payment.success', val),
      },
      { name: 'amount', sortField: 'amount', title: t('grid.Сумма'), width: 100, render: (val) => getAmount(val) },
      { name: 'amount_in', sortField: 'amount_in', title: t('grid.Внесено'), width: 100, render: (val) => getAmount(val) },
      { name: 'amount_out', sortField: 'amount_out', title: t('grid.Выдано'), width: 130, render: (val) => getAmount(val) },
      { name: 'shortage', sortField: 'shortage', title: t('grid.Недостача'), width: 130, render: (val) => getAmount(val) },
      {
        name: 'mean_type',
        title: t('dict_filter.Тип СО'),
        width: 120,
        render: (val) => data.getDictValue('payment.mean_type', val),
      },
      { name: 'mean_number', title: t('grid.СО'), width: 130 },
      { name: 'vehicle_plate', title: t('sections.ГРЗ'), width: 130 },

      { name: 'payment_terminal', title: t('grid.№ устройства'), width: 130, render: (val) => getAppNumber(val) },
      { name: 'check_number', title: t('grid.Счет N'), width: 120, numeric: true },
      { name: 'shift', title: t('grid.Смена'), width: 80, numeric: true },
    ];

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: 'auto',
      });
    }

    return fields;
  };

  return { getFields };
};
